<template>
    <div class="sidebar-menu-container">
        <div class="sidebar-main-label-grid">
            <span v-show="!showRenameInput" class="sidebar-main-label collapsable-ellipsis">{{nameActiveGroup}}</span>
            <input v-show="showRenameInput" type="text" class="photo-sidebar-rename-project"
                   :placeholder="nameActiveGroup" v-model="inputName" v-on:change="renameProject">
            <span class="edit-project-name-container" v-on:click="showInputRename">
                <SVGEditProjectName/>
            </span>
        </div>
        <div class="sidebar-gray-text">
            Выберите цвет группы:
        </div>
        <div class="grid-colors-pallet">
            <div class="grid-colors-pallet-element" v-for="color in groupColorsOptions"
                 v-bind:class="{'active-grid-colors-pallet-element': color === activeColor}"
                 v-on:click="selectGroupColor(color)">
                <div class="color-circle" v-bind:style="{'background-color': color}"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import SVGEditProjectName from "../../SVG/SVGEditProjectName";
    export default {
        name: "EditGroupSidebarMenu",
        components: {
            SVGEditProjectName
        },
        computed: {
            groupColorsOptions(){
                return this.$store.state.UI.planeGroupSettings.colorsOptions;
            },
            nameActiveGroup(){
                return this.$store.state.UI.planeGroupSettings.name;
            },
            activeColor(){
                return this.$store.state.UI.planeGroupSettings.color;
            }
        },
        methods: {
            showInputRename() {
                if(this.showRenameInput){
                    this.$store.commit('UI/planeGroupSettings/NAME', this.inputName);
                    this.inputName = '';
                } else {
                    this.inputName = this.nameActiveGroup;
                }
                this.showRenameInput = !this.showRenameInput;
            },
            renameProject() {
                this.showInputRename();
            },
            selectGroupColor(color) {
                this.$store.commit('UI/planeGroupSettings/COLOR', color);
            }
        },
        data () {
            return {
                showRenameInput: false,
                inputName: '',
            }
        },
        mounted() {
            const planeGroup = this.$store.getters["active/PLANE_GROUP"];
            if(planeGroup){
                this.$store.commit('UI/planeGroupSettings/NAME', planeGroup.name);
                this.$store.commit('UI/planeGroupSettings/COLOR', planeGroup.color);
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .grid-colors-pallet {
            grid-template-columns: max-content max-content max-content max-content max-content;
        }
        .sidebar-gray-text {
            font-size: 14px;
        }
    }

    @media screen and (min-height: 800px) {
        .grid-colors-pallet {
            grid-template-columns: max-content max-content max-content max-content max-content max-content max-content;
        }
        .sidebar-gray-text {
            font-size: 18px;
        }
    }
    .grid-colors-pallet {
        display: grid;
        grid-column-gap: 5px;
        grid-row-gap: 5px;
        margin: 20px 0;
    }

    .grid-colors-pallet-element {
        border: 2px solid white;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;

    }

    .color-circle {
        border: 2px solid white;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        cursor: pointer;
    }

    .grid-colors-pallet-element:hover {
        border-color: #ACACAC;
    }

    .active-grid-colors-pallet-element {
        border-color: #AD0C27 !important;
    }

    .sidebar-gray-text {
        color: #555555;
        margin: 20px 0;
    }
</style>
